// extracted by mini-css-extract-plugin
module.exports = {"Alerts":"Alerts_Alerts__2NViS","AlertActionButton":"Alerts_AlertActionButton__3XNy6","Alert":"Alerts_Alert__2Lqca"};